import styles from './index.module.scss';
import SectionPro from '../components/SectionPro';
import EFPicture from '@elem/compCommon/EFPicture';

const Important: React.FC = () => {
    const items = [
        {
            title: '高荷智也氏',
            desc: 'ポータブル電源は防災目的だけではなく、日常にも使える。ライフラインが止まった時の備えがすごく大事で、止まったらなにもできなくなる。また、避難所に行っても入れない場合があるので、自宅での日常の備えがすごく重要。ポータブル電源があれば、災害がおきてもスマホで安否確認・情報収集ができるだけでなく、夏の暑さ・冬の寒さにもしのげることができる。',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744981539079/image%202%20(1).png',
            h5: '',
        },
        {
            title: '和田隆昌氏',
            desc: '電気が止まるとインフラも停止し、明かりや通信が使えなくなり不安が増す。備蓄品には水・食料だけでなく電気も重要。スマホで地図や明かり、連絡、災害情報が得られるが、電源がなければ役立たない。',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744981551367/prof_image_1707241007230%20%E6%8B%B7%E8%B4%9D%202%20(1).png',
            h5: '',
        },
    ];

    return (
        <div className={`${styles.Important} GtmModuleData-section`} data-section-id={styles.Important} data-section-title="防災のプロが語る電力の重要性">
            <SectionPro title="防災のプロが語る電力の重要性">
                <div className="list">
                    {items.map((item) => {
                        return (
                            <div className="item" key={item.title}>
                                <div className="item-img">
                                    <EFPicture src={item.pc} />
                                </div>
                                <div className="text-box">
                                    <div className="title">{item.title}</div>
                                    <div className="desc">{item.desc}</div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </SectionPro>
        </div>
    );
};

export default Important;
